import { gql } from '@apollo/client';

export const imageCardFragment = gql`
  fragment imageCard on ImageCard {
    __typename
    sys {
      ...sys
    }
    heading
    description
    image {
      ...mediaImage
    }
    primaryCta {
      ...cta
    }
  }
`;
